import GameConfig from "../model/GameConfig";

export default class GameElementSkinFactory {

    /**
     * @param {GameConfig} gameConfig 
     * @param {Object} assets 
     */
    constructor(gameConfig, gameAssets) {
        this._gameConfig = gameConfig;
        this._assets = gameAssets;

        this._cachedViews = {};
    }

    getLocation(id) {        
        return new this._assets[id]();
    }

    getItem(variation) {
        var assetName = `Fish${variation['amount']}${variation['pattern']}`;
        return new this._assets[assetName];
    }
}
